import { render, staticRenderFns } from "./TransferenciasCompatibles.vue?vue&type=template&id=3f915ced&scoped=true"
import script from "./TransferenciasCompatibles.vue?vue&type=script&lang=ts"
export * from "./TransferenciasCompatibles.vue?vue&type=script&lang=ts"
import style0 from "./TransferenciasCompatibles.vue?vue&type=style&index=0&id=3f915ced&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f915ced",
  null
  
)

export default component.exports